module.exports = __webpack_public_path__ + "img/report-icon.50350832.svg";